module.exports = "<span  title=\"{{'WorkLog_SubItemLog' | translate}}\" style=\"font-size:12px;cursor:pointer;\"ng-if=\"$ctrl.activitySubItems.length > 0\" \r\nuib-popover-template=\"'popover-sub-items'\" popover-placement=\"auto top\" popover-trigger=\"'outsideClick'\">\r\n    <a>({{$ctrl.durationView}})</a>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ../widgets/duration/childDuration/child-duration.component.html
// module id = 734
// module chunks = 0